export default __webpack_public_path__ + "static/web20231128-0dd86aa0735a9aa2f6dcb566cb9a607e.png";